import React from 'react';
import PropTypes from 'prop-types';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { StyledHideCalendarButton, StyledHideCalendarLabel } from './styled';

// eslint-disable-next-line react/display-name
const HideCalendarButton = React.memo(({ isVisible, toggleIsVisible }) => (
  <StyledHideCalendarButton onClick={toggleIsVisible}>
    <FontAwesomeIcon
      size="2x"
      icon={isVisible ? 'eye-slash' : 'eye'}
      data-test={isVisible ? 'eye-show' : 'eye-hide'}
    />
    <StyledHideCalendarLabel>
      {isVisible ? 'Hide' : 'Show'}
    </StyledHideCalendarLabel>
  </StyledHideCalendarButton>
));

HideCalendarButton.propTypes = {
  isVisible: PropTypes.bool.isRequired,
  toggleIsVisible: PropTypes.func.isRequired,
};

export default HideCalendarButton;